import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import cn from 'classnames';
import React, { KeyboardEvent } from 'react';
import { Toolbar } from './Toolbar';
import './ToolbarCategories.scss';

export interface ToolbarCategoriesProps {
  categories: string[];
  selected: string;
  onSelected: (category: string, index: number | undefined) => void;
  resetSelectionLabel?: string;
  isLoading?: boolean;
}

export interface ToolbarCategoryButtonProps {
  categoryName: string;
  selected: boolean;
  onClick: (categoryName: string) => void;
}

const ToolbarCategoryButton: React.FC<ToolbarCategoryButtonProps> = ({
  categoryName,
  selected,
  onClick,
}) => {
  const keyDownHandler = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter') {
      onClick(categoryName);
    }
  };

  return (
    <div
      role="button"
      className={cn('toolbarCategoryButton', {
        selected,
      })}
      tabIndex={0}
      onClick={() => onClick(categoryName)}
      onKeyDown={keyDownHandler}
    >
      {categoryName}
    </div>
  );
};

export const ToolbarCategories: React.FC<ToolbarCategoriesProps> = ({
  categories,
  selected,
  onSelected,
  resetSelectionLabel,
  isLoading,
}) => {
  return (
    <Toolbar className="toolbarCategories">
      {isLoading && (
        <Skeleton className="toolbarCategoriesSkeleton">
          <SkeletonItem size={24} className="toolbarCategoriesSkeletonItem width70" />
          <SkeletonItem size={24} className="toolbarCategoriesSkeletonItem width110" />
          <SkeletonItem size={24} className="toolbarCategoriesSkeletonItem width90" />
        </Skeleton>
      )}

      {!isLoading && (
        <>
          {resetSelectionLabel && (
            <ToolbarCategoryButton
              categoryName={resetSelectionLabel}
              selected={selected === ''}
              onClick={() => onSelected('', undefined)}
            />
          )}
          {categories.map((category, index) => (
            <ToolbarCategoryButton
              key={category}
              categoryName={category}
              selected={selected === category}
              onClick={() => onSelected(category, index)}
            />
          ))}
        </>
      )}
    </Toolbar>
  );
};
